import { envType } from '@atlassiansox/analytics-web-client/analytics-web-types';

export function getEnvironment(): string {
	// Gaurd for running in the browser - if SSR (somehow) just return prod
	if (typeof window === 'undefined') {
		return envType.PROD;
	}
	const { hostname } = window.location;
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		return envType.LOCAL;
	}
	if (hostname.includes('.dev.')) {
		return envType.STAGING;
	}
	if (hostname.includes('.stg.')) {
		return envType.STAGING;
	}
	return envType.PROD;
}
